
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PerformoSettings, Property, PropertiesApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    settings: 'settings',
    currentPropertyId: 'currentPropertyId',
    currentProperty: 'currentProperty',
    propertyApi: 'propertiesApi'
  })
})
export default class PropertyPicker extends Vue {
  @Prop({ required: true })
  private value!: string;

  @Prop({ default: false, type: Boolean })
  private inline!: boolean;

  @Prop({ default: false, type: Boolean })
  private hideLabel!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private required?: boolean;

  private settings!: PerformoSettings;
  private currentPropertyId!: string;
  private currentProperty!: Property;

  @Prop({ required: false, default: true })
  private setGlobalCurrentProperty?: boolean;

  get getValue() {
    if (this.value) {
      return this.value.toUpperCase();
    }
    return '';
  }

  private propertyApi!: PropertiesApi;
  private properties: Property[] = [];

  get propertiesSorted() {
    if (!this.properties) {
      return null;
    }
    return this.properties.sort((a, b) => {
      if (a.propertyName && b.propertyName) {
        return a.propertyName.localeCompare(b.propertyName);
      }
      return 0;
    });
  }

  private changeHandler() {
    const pickedValue: string = (this.$refs.selectedValue as HTMLSelectElement)
      .value;

    // always emit the input event, so this control works like a regular <select> element.
    this.$emit('input', pickedValue);

    // if the user wants the global store updated, commit the change to vuex
    if (this.setGlobalCurrentProperty) {
      this.$store.commit('setCurrentPropertyId', pickedValue);
      window.localStorage.setItem('currentPropertyId', pickedValue);

      const pickedProperty = this.properties.find(
        (i) => i.propertyId === pickedValue
      );
      if (pickedProperty) {
        this.$store.commit('setCurrentProperty', pickedProperty);
      }
    }
  }

  private async mounted() {
    this.properties = await this.propertyApi.getMyProperties();
    if (this.properties.length === 0) {
      alert(
        'There are no viewable properties for this account. Please contact support.'
      );
      return;
    }

    const contactPropertyId = this.$store.state.performoUser.contact.propertyId;

    const localStorageProperty = this.properties.find(
      (i) => i.propertyId === window.localStorage.getItem('currentPropertyId')
    );

    const contactProperty = this.properties.find(
      (i) => i.propertyId === contactPropertyId
    );

    if (
      this.settings.setDefaultPropertyToContactPropertyId &&
      contactPropertyId &&
      contactProperty
    ) {
      this.$store.commit('setCurrentPropertyId', contactPropertyId);
      this.$store.commit('setCurrentProperty', contactProperty);
    } else if (localStorageProperty) {
      this.$store.commit(
        'setCurrentPropertyId',
        localStorageProperty.propertyId
      );
      this.$store.commit('setCurrentProperty', localStorageProperty);
    } else {
      // default currentPropertyId to first element in properties array and commit to vuex
      this.$store.commit('setCurrentPropertyId', this.properties[0].propertyId);
      this.$store.commit('setCurrentProperty', this.properties[0]);
    }
  }
}
